import React, { useState, useEffect, useContext } from 'react';
import { connect } from "react-redux";
import { debug } from "../../utils";
import { showSuccessToast } from "../../validation/ToastContainer"
import Dialog from '@mui/material/Dialog';
import { Switch } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';

import "react-datepicker/dist/react-datepicker.css";

import VulscanTypeField from "./VulscanTypeField";
import * as vulscanService from "./vulscanService";
import VulscanTargetField from "./VulscanTargetField";
import { PopupContext } from "../../index";
import { getDeletePopup } from "../../view/popup/PopupContainer";


function ScheduleScanButton({ types, selectedType, setType, inputTarget, setTarget, inputCommand, userId, userRole }) {
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(-1);
    const [viewSchedules, setViewSchedules] = useState(false);
    const [selectedRecurrenceFrequency, setSelectedRecurrenceFrequency] = useState(1);
    const [selectedPattern, setSelectedPattern] = useState('day');
    const [selectedDays, setSelectedDays] = useState([]);
    const [selectedMonthOption, setSelectedMonthOption] = useState('1');
    const [selectedYearOption, setSelectedYearOption] = useState('1');
    const [selectedYearNameOption, setSelectedYearNameOption] = useState('Jan');
    const [hours, setHours] = useState('1');
    const [minutes, setMinutes] = useState('5');
    const [period, setPeriod] = useState('AM');    
    const [scanScheduleResult, setScanScheduleResult] = useState(null);
    const { setPopup } = useContext(PopupContext);

    useEffect(() => {
        //const today = new Date();
        //setSelectedDays([today.toLocaleDateString('en-US', { weekday: 'long' })]);
    }, []);

    useEffect(() => {
        if (viewSchedules) {
            const fetchData = async () => {
                const result = await vulscanService.getScheduledScans(userRole);
                setScanScheduleResult(result);
            };
            fetchData();
        }
        // eslint-disable-next-line
    }, [viewSchedules]);
    //     setTarget(value);
    //     //let commandText = state.command;
    //     // setState({
    //     //   ...state,
    //     // target: value,
    //     // //command: commandText + " " + state.target
    //     // });
    // };

    // const onTypeChange = (value) => {
    //     setScanType(value);
    //     setCommand(value.command);
    //     // setState({
    //     //   ...state,
    //     //   selectedType: value.type,
    //     //   selectedTypeId: value.id,
    //     //   details: value.details,
    //     //   command: value.command,
    //     // });
    // }      

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleOnSubmit = async () => {
        const startTimeDb = new Date();
        startTimeDb.setHours(period === 'AM' ? parseInt(hours) : parseInt(hours) + 12);
        startTimeDb.setMinutes(parseInt(minutes));
        startTimeDb.setSeconds(0);
        const scanSchedule = {
            userId: userId,
            userRole: userRole,
            scanTypeId: selectedType.id,
            scanType: selectedType.type,
            target: inputTarget,
            command: inputCommand,
            startTime: startTimeDb,
            recurrencePattern: selectedPattern,
            recurEvery: selectedRecurrenceFrequency,
            selectedWeekDays: selectedDays.join(','),
            selectedMonthDay: selectedMonthOption,
            selectedYearMonth: selectedYearNameOption,
            selectedYearDay: selectedYearOption,
            active: true
        }
        vulscanService.scheduleScan(scanSchedule)
            .then(() => { showSuccessToast(`Nmap Scan Schedule is saved`, 'Scan Schedule') });
        setOpen(false);
    }

    const handleToggleChange = (key) => {
        const updatedScanScheduleResult = {
            ...scanScheduleResult,
            [key]: {
                ...scanScheduleResult[key],
                active: !scanScheduleResult[key].active
            }
        };
        setScanScheduleResult(updatedScanScheduleResult);

        const scanScheduleStatus = {
            id: parseInt(scanScheduleResult[key].id),
            active: !scanScheduleResult[key].active
        };
        vulscanService.updateScheduleActiveFlag(scanScheduleStatus)
            .then(() => { showSuccessToast(`Scan Schedule is Updated`, 'Schedule Scan'); });
    };

    //#region delete Scan Schedule
    const handleClickDeleteOpen = (id) => {
        setDeleteId(id);
        setPopup(getDeletePopup(
            'Are you sure you want to delete this schedule?',
            'Delete Schedule',
            () => handleDelete(id),
            undefined,
            'Delete Schedule'
        ));
    };

    const handleDelete = (id = deleteId) => {
        vulscanService.deleteScheduleScan(id)
        .then(() => {
            showSuccessToast(`Nmap Scan Schedule is Deleted`, 'Delete Schedule');
            vulscanService.getScheduledScans(id)
                .then((result) => {
                    setScanScheduleResult(result);
                })
                .catch((error) => {
                    console.error('Error fetching updated schedule data:', error);
                });
            setViewSchedules(false);
        })
        .catch((error) => {
            console.error('Error deleting schedule:', error);
        });
    };
    //#endregion

    const handleClose = () => {
        setOpen(false);
        setViewSchedules(false);
    };

    const handleHourChange = (event) => {
        setHours(event.target.value);
    };

    const handleMinuteChange = (event) => {
        setMinutes(event.target.value);
    };

    const handlePeriodChange = (e) => {
        setPeriod(e.target.value);
    };

    const handleRadioChange = (event) => {
        setSelectedMonthOption(event.target.value);
    };

    const handleRadioChangeYearDate = (event) => {
        setSelectedYearOption(event.target.value);
    };

    const handleRadioChangeYearMonthname = (event) => {
        setSelectedYearNameOption(event.target.value);
    };

    const toggleWeekDay = (day) => {
        setSelectedDays((currentDays) => currentDays.includes(day)
            ? currentDays.filter((currentDay) => currentDay !== day)
            : [...currentDays, day]);
    };

    const recurrenceSummary = selectedPattern === 'day'
        ? `The scan will run every ${selectedRecurrenceFrequency === 1 ? 'day' : `${selectedRecurrenceFrequency} days`}.`
        : selectedPattern === 'week'
            ? `The scan will run every ${selectedRecurrenceFrequency === 1 ? 'week' : `${selectedRecurrenceFrequency} weeks`}${selectedDays.length ? ` on ${selectedDays.join(', ')}` : ''}.`
            : selectedPattern === 'month'
                ? `The scan will run on day ${selectedMonthOption || 1} every ${selectedRecurrenceFrequency === 1 ? 'month' : `${selectedRecurrenceFrequency} months`}.`
                : `The scan will run every year on ${selectedYearNameOption || 'Jan'} ${selectedYearOption || 1}.`;

    const isFormValid = Boolean(selectedType && inputTarget);

    return (
        <>
            <div className="network-scan-secondary-action-v2"
                onClick={handleClickOpen}>Schedule Scan                    
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="schedule-validation-dialog-title"
                aria-describedby="schedule-validation-dialog-description"
                maxWidth={false}
                PaperProps={{
                    className: `modal-v2-root modal-v2-schedule-dialog modal-v2-vulscan-schedule-dialog${viewSchedules ? ' modal-v2-schedule-dialog-list' : ''}`
                }}
                sx={{
                    '& .MuiBackdrop-root': {
                        backdropFilter: 'blur(4px)',
                        background: 'linear-gradient(rgba(2, 6, 23, 0.58), rgba(2, 6, 23, 0.58)), radial-gradient(circle at top, rgba(78, 188, 228, 0.16), transparent 44%)'
                    }
                }}
            >
                <div className="modal-v2-schedule-header">
                    <div className="modal-v2-schedule-header-top">
                        <div className="modal-v2-schedule-header-copy">
                            {viewSchedules ? (
                                <p className="modal-v2-schedule-list-title">Vulnerability Scan Schedules</p>
                            ) : (
                                <div className="modal-v2-schedule-heading-wrap">
                                    <div className="modal-v2-schedule-heading-icon" aria-hidden="true">
                                        <CalendarMonthOutlinedIcon />
                                    </div>
                                    <div>
                                        <h2 id="schedule-validation-dialog-title" className="modal-v2-schedule-heading">Schedule Vulnerability Scan</h2>
                                        <p className="modal-v2-schedule-subheading">Automate recurring Nmap vulnerability scans</p>
                                    </div>
                                </div>
                            )}
                        </div>
                        <button type="button" className="close modal-v2-close modal-v2-schedule-close" aria-label="Close" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </button>
                    </div>
                </div>

                <div className="modal-body modal-v2-body modal-v2-schedule-body">
                    {viewSchedules ? (
                        <>
                            <div className="modal-v2-schedule-list-table-wrap">
                                {!scanScheduleResult || Object.keys(scanScheduleResult).length === 0 ? (
                                    <div className="modal-v2-schedule-empty-state">No vulnerability scan schedules found.</div>
                                ) : (
                                    <table className="modal-v2-schedule-list-table">
                                        <thead>
                                            <tr className="modal-v2-schedule-list-header-row">
                                                <th>Start Time</th>
                                                <th>Scheduled By</th>
                                                <th>Scan Type</th>
                                                <th>Target</th>
                                                <th>Pattern</th>
                                                <th>Recurrence</th>
                                                <th>Enable</th>
                                                <th>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(scanScheduleResult).map((key, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {(() => {
                                                            const startTime = new Date(scanScheduleResult[key].startTime);
                                                            const formattedStartTime = startTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
                                                            return formattedStartTime;
                                                        })()}
                                                    </td>
                                                    <td>{scanScheduleResult[key].userRole}</td>
                                                    <td>{scanScheduleResult[key].scanType}</td>
                                                    <td>{scanScheduleResult[key].target}</td>
                                                    <td>{scanScheduleResult[key].recurrencePattern}</td>
                                                    <td>
                                                        {scanScheduleResult[key].recurrencePattern === 'day' && (
                                                            <>Every {scanScheduleResult[key].recurEvery === 1 ? 'day' : `${scanScheduleResult[key].recurEvery} days`}</>
                                                        )}
                                                        {scanScheduleResult[key].recurrencePattern === 'week' && (
                                                            <>Every {scanScheduleResult[key].recurEvery === 1 ? 'week' : `${scanScheduleResult[key].recurEvery} weeks`} on {scanScheduleResult[key].selectedWeekDays}</>
                                                        )}
                                                        {scanScheduleResult[key].recurrencePattern === 'month' && (
                                                            <>Day {scanScheduleResult[key].selectedMonthDay}, every {scanScheduleResult[key].recurEvery === 1 ? 'month' : `${scanScheduleResult[key].recurEvery} months`}</>
                                                        )}
                                                        {scanScheduleResult[key].recurrencePattern === 'year' && (
                                                            <>Every {scanScheduleResult[key].selectedYearMonth} {scanScheduleResult[key].selectedYearDay}</>
                                                        )}
                                                    </td>
                                                    <td className="modal-v2-schedule-list-cell-center">
                                                        <Switch
                                                            checked={scanScheduleResult[key].active}
                                                            onChange={() => handleToggleChange(key)}
                                                        />
                                                    </td>
                                                    <td className="modal-v2-schedule-list-cell-center">
                                                        <button
                                                            type="button"
                                                            className="modal-v2-schedule-table-delete"
                                                            aria-label="Delete schedule"
                                                            onClick={() => handleClickDeleteOpen(scanScheduleResult[key].id)}
                                                        >
                                                            <DeleteOutlineOutlinedIcon fontSize="small" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="modal-v2-schedule-form">
                            <div className="card modal-v2-schedule-card">
                                <div className="card-body">
                                    <div className="modal-v2-schedule-card-heading modal-v2-schedule-section-head">
                                        <span className="modal-v2-schedule-section-icon" aria-hidden="true">
                                            <FormatListBulletedIcon fontSize="small" />
                                        </span>
                                        <h3 className="modal-v2-schedule-section-title">Scan Configuration</h3>
                                    </div>
                                    <div className="modal-v2-vulscan-target-grid">
                                        <div>
                                            <VulscanTypeField types={types}
                                                value={selectedType}
                                                onChange={setType}/>
                                        </div>
                                        <div>
                                            <VulscanTargetField value={inputTarget}
                                                onChange={setTarget}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card modal-v2-schedule-card modal-v2-schedule-card--time">
                                <div className="card-body">
                                    <div className="modal-v2-schedule-card-heading modal-v2-schedule-section-head">
                                        <span className="modal-v2-schedule-section-icon" aria-hidden="true">
                                            <ScheduleOutlinedIcon fontSize="small" />
                                        </span>
                                        <h3 className="modal-v2-schedule-section-title">Schedule Time</h3>
                                    </div>
                                    <div className="modal-v2-schedule-time-row">
                                        <div className="modal-v2-vulscan-time-field">
                                            <label htmlFor="scheduleHour">Hour</label>
                                            <select className="modal-v2-schedule-native-select" id="scheduleHour" value={hours} onChange={handleHourChange}>
                                                {Array.from({ length: 12 }, (_, index) => (
                                                    <option key={index + 1} value={index + 1}>{index + 1} hr.</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="modal-v2-vulscan-time-field">
                                            <label htmlFor="scheduleMin">Minute</label>
                                            <select className="modal-v2-schedule-native-select" id="scheduleMin" value={minutes} onChange={handleMinuteChange}>
                                                {Array.from({ length: 12 }, (_, index) => (
                                                    <option key={index + 1} value={(index + 1) * 5}>{(index + 1) * 5} min.</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="modal-v2-vulscan-time-field">
                                            <label htmlFor="schedulePeriod">Period</label>
                                            <select className="modal-v2-schedule-native-select" id="schedulePeriod" value={period} onChange={handlePeriodChange}>
                                                <option value="AM">AM</option>
                                                <option value="PM">PM</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card modal-v2-schedule-card modal-v2-schedule-card--recurrence">
                                <div className="card-body">
                                    <div className="modal-v2-schedule-card-heading modal-v2-schedule-section-head">
                                        <span className="modal-v2-schedule-section-icon" aria-hidden="true">
                                            <CalendarMonthOutlinedIcon fontSize="small" />
                                        </span>
                                        <h3 className="modal-v2-schedule-section-title">Recurrence Pattern</h3>
                                    </div>
                                    <div className="modal-v2-schedule-recurrence">
                                        <div className="modal-v2-schedule-recurrence-controls">
                                            <div className="modal-v2-schedule-recurrence-control">
                                                <span className="modal-v2-schedule-inline-label">Recur every</span>
                                                <div className="modal-v2-schedule-repeat-fields">
                                                    {selectedPattern !== 'year' && (
                                                        <input
                                                            className="oct_form-control-default oct_textalign-center oct_recurrence-frequency-input-v2"
                                                            type="number"
                                                            min="1"
                                                            value={selectedRecurrenceFrequency}
                                                            onChange={(event) => setSelectedRecurrenceFrequency(Math.max(1, parseInt(event.target.value || 1, 10)))}
                                                        />
                                                    )}
                                                    <select className="modal-v2-schedule-native-select modal-v2-vulscan-pattern-select" name="pattern" id="pattern" value={selectedPattern} onChange={(event) => setSelectedPattern(event.target.value)}>
                                                        <option value="day">Day</option>
                                                        <option value="week">Week</option>
                                                        <option value="month">Month</option>
                                                        <option value="year">Year</option>
                                                    </select>
                                                </div>
                                            </div>
                                                {selectedPattern === 'week' && (
                                                    <div className="modal-v2-schedule-weekday-card">
                                                        <span className="modal-v2-schedule-inline-label">On days</span>
                                                        <div className="modal-v2-schedule-weekday-pills">
                                                            {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day) => (
                                                                <button
                                                                    type="button"
                                                                    key={day}
                                                                    aria-pressed={selectedDays.includes(day)}
                                                                    className={`modal-v2-schedule-weekday-pill ${selectedDays.includes(day) ? 'is-selected' : ''}`}
                                                                    onClick={() => toggleWeekDay(day)}
                                                                >
                                                                    <span className="modal-v2-schedule-weekday-pill-short">{day.slice(0, 3)}</span>
                                                                    <span className="modal-v2-schedule-weekday-pill-full">{day}</span>
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                                {selectedPattern === 'month' && (
                                                    <div className="modal-v2-schedule-specific-field">
                                                        <label className="modal-v2-schedule-inline-label" htmlFor="scheduleMonthDay">On day</label>
                                                        <select className="modal-v2-schedule-native-select modal-v2-vulscan-pattern-select" id="scheduleMonthDay" value={selectedMonthOption || 1} onChange={handleRadioChange}>
                                                            {Array.from({ length: 31 }, (_, index) => (
                                                                <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}
                                                {selectedPattern === 'year' && (
                                                    <div className="modal-v2-schedule-specific-grid modal-v2-schedule-specific-grid--year">
                                                        <div className="modal-v2-schedule-specific-field">
                                                            <label className="modal-v2-schedule-inline-label" htmlFor="scheduleYearMonth">On month</label>
                                                            <select className="modal-v2-schedule-native-select" id="scheduleYearMonth" value={selectedYearNameOption || 'Jan'} onChange={handleRadioChangeYearMonthname}>
                                                                {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((month, index) => (
                                                                    <option key={index} value={month}>{month}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="modal-v2-schedule-specific-field">
                                                            <label className="modal-v2-schedule-inline-label" htmlFor="scheduleYearDay">On day</label>
                                                            <select className="modal-v2-schedule-native-select" id="scheduleYearDay" value={selectedYearOption || 1} onChange={handleRadioChangeYearDate}>
                                                                {Array.from({ length: 31 }, (_, index) => (
                                                                    <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <div className="modal-v2-schedule-recurrence-summary" id="schedule-validation-dialog-description">
                                            <InfoOutlinedIcon fontSize="small" />
                                            <span>{recurrenceSummary}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="modal-footer modal-v2-footer modal-v2-schedule-footer">
                    <div className="modal-v2-footer-note">
                        {!viewSchedules && <><span className="modal-v2-footer-note-star">*</span> Scan type and target are required</>}
                    </div>
                    <div className="modal-v2-footer-actions">
                        {viewSchedules ? (
                            <button type="button" className="btn modal-v2-btn modal-v2-btn-primary" onClick={() => setViewSchedules(false)}>
                                Back
                            </button>
                        ) : (
                            <>
                                <button type="button" className="btn modal-v2-btn modal-v2-btn-outline" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className={`btn modal-v2-btn modal-v2-btn-primary${!isFormValid ? ' disabled' : ''}`}
                                    onClick={isFormValid ? handleOnSubmit : undefined}
                                >
                                    <AddIcon fontSize="small" />
                                    Create Schedule
                                </button>
                                <button type="button" className="btn modal-v2-btn modal-v2-btn-primary" onClick={() => setViewSchedules(true)}>
                                    <FormatListBulletedIcon fontSize="small" />
                                    View Schedules
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </Dialog>
        </>
    );
}

function mapStateToProps(state) {
    debug("ScheduleScanButton mapStateToProps", state);
    return {
        firstName: state.auth.firstName,
        lastName: state.auth.lastName,
        userId: state.auth.pk,
        userRole: state.auth.userRole.name
    };
}

export default connect(mapStateToProps)(ScheduleScanButton);
